<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ isEdit ? "Modifier le contact" : "Nouveau contact" }}
      </div>
      <div v-if="isEdit" class="right">
        <v-ons-toolbar-button @click="deleteClientConfirm">
          <v-ons-progress-circular v-if="isSubmitDelete" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          <v-ons-icon v-else-if="isInscrit && isAcces" icon="ban"></v-ons-icon>
          <v-ons-icon v-else-if="isInscrit" icon="unlink"></v-ons-icon>
          <v-ons-icon v-else icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <template v-if="isContactReadonly">
        <v-ons-list-title modifier="perflist">
          Informations du compte Perfarmer
        </v-ons-list-title>
        <v-ons-list modifier="noborder perflist">

          <app-label label="Agriculteur">
            <div slot="right" class="right">
              {{ client.name }}
            </div>
          </app-label>

          <app-label label="Téléphone">
            <div slot="right" class="right">
              {{ client.tel }}
            </div>
          </app-label>

          <app-label label="Email">
            <div slot="right" class="right">
              {{ client.email }}
            </div>
          </app-label>

        </v-ons-list>
      </template>

      <v-ons-list-title v-if="isContactReadonly" modifier="perflist">
        Informations du contact
      </v-ons-list-title>
      <v-ons-list modifier="noborder perflist">

        <template v-if="negoceInfos.tc_list">
          <app-label input-id="inputTC" label="Technicien" :error-msg-list="errorMsgList"></app-label>
          <v-ons-list-item modifier="nodivider input">
            <div class="center">
              <v-ons-select :modifier="client.tc !== '' ? 'underbar' : 'underbar placeholder'" v-model="client.tc" ref="inputTC">
                <option value="" hidden>Choisissez un technicien</option>
                <option v-for="(labelTC, idTC) in negoceInfos.tc_list" :key="idTC" :value="idTC">
                  {{ labelTC }}
                </option>
              </v-ons-select>
            </div>
          </v-ons-list-item>
        </template>

        <app-label input-id="inputFerme" label="Nom de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputFerme" ref="inputFerme" v-model="client.ferme" placeholder="Entrez une raison sociale"></app-input>
        
        <template v-if="! isContactReadonly">
          <app-label input-id="inputTel" label="Numéro de téléphone portable" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputTel" ref="inputTel" input-type="tel" v-model="client.tel" placeholder="Entrez un 06/07"></app-input>

          <app-label input-id="inputEmail" label="Adresse email" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="client.email" placeholder="Entrez un email"></app-input>

          <app-label input-id="inputName" label="Nom + prénom du représentant" :error-msg-list="errorMsgList">
          </app-label>
          <app-input input-id="inputName" ref="inputName" v-model="client.name" placeholder="Entrez un nom + prénom"></app-input>
        </template>

        <app-label input-id="inputLigne4" label="Adresse de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputLigne4" ref="inputLigne4" v-model="client.ligne4" placeholder="Entrez une adresse"></app-input>

        <app-label input-id="inputCp" label="Code postal de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputCp" ref="inputCp" input-type="tel" v-model="client.cp" placeholder="Entrez un code postal"></app-input>

        <app-label input-id="inputVille" label="Commune de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputVille" ref="inputVille" v-model="client.ville" placeholder="Entrez une commune"></app-input>

        <app-label input-id="inputErp" label="Code tiers" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputErp" ref="inputErp" v-model="client.erp" placeholder="Entrez un code tiers"></app-input>

        <template v-if="client.silo !== undefined || negoceInfos.silo">
          <app-label input-id="inputSilo" label="Code silo" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputSilo" ref="inputSilo" v-model="client.silo" placeholder="Entrez un code silo"></app-input>
        </template>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveClient">
          {{ isEdit ? 'Modifier le contact' : 'Ajouter le contact' }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>
      
    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      idContact: null,
      isInscrit: false,
      isAcces: false,
      isContactEdit: false,
      client: {
        ferme: '',
        tel: '',
        email: '',
        name: '',
        ligne4: '',
        cp: '',
        ville: '',
        erp: '',
        tc: '',
        silo: undefined
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    isEdit() {
      return this.idContact !== null;
    },
    // Coordonnées (nom / tél / email) en lecture seule : uniquement quand la fiche est rattachée à
    // un compte Perfarmer ET que beta sert encore les coordonnées de ce compte. Dès que beta sert
    // celles de la fiche (`is_contact_edit`), le TC les édite comme sur une fiche non rattachée —
    // ce sont elles qui reçoivent l'OTP et le mail de contrat. Le rattachement lui-même reste
    // signalé par `isInscrit` : badge « Inscrit sur Perfarmer » et action Dissocier/Bloquer.
    isContactReadonly() {
      return this.isInscrit && ! this.isContactEdit;
    }
  },
  methods: {
    async saveClient() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      if(this.negoceInfos.tc_list && ! this.client.tc){
        this.setErrorMsgList('inputTC', "Le technicien est obligatoire");
      }

      if(! this.client.ferme && ! this.client.name){
        this.setErrorMsgList('inputFerme', "Le nom de l'exploitation (ou du représentant) est obligatoire");
      }

      if (this.client.tel) {
        var telRegex = /^(((\+|00)33|0)\s*[1-9]|(\+|00)32\s*4)([\s.-]*\d{2}){4}$/;
        if (!telRegex.test(this.client.tel)) {
          this.setErrorMsgList('inputTel', "Le numéro de téléphone n'a pas un format valide");
        }
      }

      if (this.client.email) {
        var emailRegex = /^([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)@(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,})$/;
        if (!emailRegex.test(this.client.email)) {
          this.setErrorMsgList('inputEmail', "L'email n'a pas un format valide");
        }
      }

      if (this.client.cp) {
        var cpRegex = /^\d{4}\d?$/; // cp belge 4 digits
        if (!cpRegex.test(this.client.cp)) {
          this.setErrorMsgList('inputCp', "Le code postal n'a pas un format valide");
        }
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        id_negoce: this.negoceId,
        data: {}
      };
      for (const key in this.client) {
        if(this.isContactReadonly && ['tel', 'email', 'name'].indexOf(key) != -1){
          continue;
        }
        body.data[key] = this.client[key];
      }
      if (this.isEdit) {
        body.id_contact = this.idContact;
      }

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/client');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        response.negoce.request = store.data.negoce.request;
        response.negoce.suggest = store.data.negoce.suggest;
        store.data.negoce = response.negoce;
        await this.ionicStorage.set('negoce', response.negoce);

        this.pageStack.length > 1 && this.pageStack.pop();
        if (this.isEdit) {
          this.$showToast('Contact modifié');
        } else {
          this.$showToast('Nouveau contact ajouté');
        }

      } catch(error) {
        this.handleError(error);
      }
    },
    deleteClientConfirm() {
      var msg, btn;
      if(this.isInscrit && this.isAcces){
        msg = "Êtes-vous sûr de vouloir bloquer l'accès à vos prix pour ce contact ?";
        btn = 'Bloquer';
      } else if(this.isInscrit){
        msg = "Êtes-vous sûr de vouloir dissocier ce contact du compte Perfarmer ?";
        btn = 'Dissocier';
      } else {
        msg = "Êtes-vous sûr de vouloir supprimer ce contact ?"
            + " Vous ne pourrez plus enregistrer de vente pour ce contact.";
        btn = 'Supprimer';
      }
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: msg,
        buttonLabels: ['Annuler', btn],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteClient();
          }
        }.bind(this)
      });
    },
    async deleteClient() {
      if (this.isSubmitDelete) {
        return;
      }
      this.isSubmitDelete = true;

      const call = {
        method: 'DELETE',
        path: this.getPath('/negoce/client'),
        data: {
          id: this.user.id,
          date: this.user.date,
          id_negoce: this.negoceId,
          id_contact: this.idContact
        }
      };

      const fetchInit = this.$getFetchInit(call.method);
      fetchInit.body = JSON.stringify(call.data);
      const callPath = this.$apiDomain + call.path;
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        response.negoce.request = store.data.negoce.request;
        response.negoce.suggest = store.data.negoce.suggest;
        store.data.negoce = response.negoce;
        await this.ionicStorage.set('negoce', response.negoce);

        if(this.isAcces){
          this.$showToast('Accès bloqué');
          this.pageStack.pop();
        } else if(this.isInscrit){
          this.$showToast('Contact dissocié');
          this.pageStack.pop();
        } else {
          this.$showToast('Contact supprimé');
          this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
        }
        

      } catch(error) {
        this.handleError(error, 'de la modification');
      }
    }
  }
}
</script>
